import React from 'react';

import classnames from 'classnames';

import { usePagination, DOTS } from './usePagination';

const Pagination = (props) => {
  const { onPageChange, totalCount, siblingCount = 1, currentPage, pageSize, onPageClickScrollHref, className } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (paginationRange.length < 2) {
    return null;
  }

  // Imposta il massimo numero di risultati gestibili
  const MAX_RESULTS = 1000;

  // Calcola il totale effettivo da usare per la paginazione
  const effectiveTotal = Math.min(totalCount, MAX_RESULTS);

  // Calcola l'indice zero-based dell'ultima pagina assoluta
  const lastPageIndex = Math.max(0, Math.ceil(effectiveTotal / pageSize) - 1);

  const onFirst = () => {
    onPageChange(0);
  };

  const onLast = () => {
    onPageChange(lastPageIndex);
  };

  const onNext = () => {
    if (currentPage < lastPageIndex) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <>
      <div className="pagination_section">
        <div className="pagination_item">
          <ul>
            {/* Freccia doppia indietro */}
            <li className={currentPage === 0 ? 'first disable' : 'first'}>
              <a href="#" onClick={e => { e.preventDefault(); if (currentPage !== 0) onFirst(); }}>{'<<'}</a>
            </li>

            {/* Freccia singola indietro */}
            <li className={currentPage === 0 ? 'prev disable' : 'prev'}>
              <a href="#" onClick={e => { e.preventDefault(); if (currentPage > 0) onPrevious(); }} />
            </li>

            {paginationRange.map((pageNumber) => {
              if (pageNumber === DOTS) {
                return <li className="pagination-item dots" key="dots">&#8230;</li>;
              }

              // pageNumber è 1-based, currentPage è 0-based
              return (
                <li
                  key={pageNumber}
                  style={{ cursor: 'pointer' }}
                  className={classnames('pagination-item', {
                    selected: pageNumber - 1 === currentPage,
                  })}
                  onClick={() => onPageChange(pageNumber - 1)}
                >
                  <a href={'#' + onPageClickScrollHref}>
                    {pageNumber - 1 === currentPage ? (
                      <b>
                        <u>{pageNumber}</u>
                      </b>
                    ) : (
                      pageNumber
                    )}
                  </a>
                </li>
              );
            })}

            {/* Freccia singola avanti */}
            <li className={currentPage === lastPageIndex ? 'next disable' : 'next'}>
              <a
                onClick={e => { e.preventDefault(); if (currentPage < lastPageIndex) onNext(); }}
                href="#"
              />
            </li>

            {/* Freccia doppia avanti: va sempre all'ultima pagina assoluta */}
            <li className={currentPage === lastPageIndex ? 'last disable' : 'last'}>
              <a href="#" onClick={e => { e.preventDefault(); if (currentPage !== lastPageIndex) onLast(); }}>{'>>'}</a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Pagination;